export default function (error) {
	return this.html.tag('li', {class: this.html.classes('field__error')}, {}, error);
}
